import { useEffect } from 'react';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import '@maplibre/maplibre-gl-leaflet';

export default function VectorLayer() {
  const map = useMap();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      L.maplibreGL({
        style: 'https://maps-assets.geocod.io/styles/geocodio.json',
        customAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);
    }
  });
  return null;
}